import { Seller } from "./Seller";

interface GigImageInterface {
    url: string, 
    assetId?: string,
    position: number,
}

interface PriceTableInterface {
    minPrice: number,
    maxPrice: number,
    duration: number,
    durationUnit:  string,
    description: string,
}

interface GigMetrics {
    totalOrders: number,
    totalEarningsInPaisa: number
}

export default interface GigInterface {
    id: string,
    title: string,
    description: string,
    coverImg: string,
    coverImgAssetId?: string,
    minPrice: number,
    rating?: number,
    noOfRatings: number,
    isListed: boolean,
    priceTable: PriceTableInterface[],
    gigImgs: GigImageInterface[],
    seller: Seller,
    gigMetrics?: GigMetrics,
    subcategory: string,
}

export class Gig implements GigInterface {
    id: string;
    title: string;
    description: string;
    coverImg: string;
    coverImgAssetId?: string;
    minPrice: number;
    rating?: number | undefined;
    noOfRatings: number;
    priceTable: PriceTableInterface[];
    gigImgs: GigImageInterface[];
    isListed: boolean;
    seller: Seller;
    gigMetrics?: GigMetrics;
    subcategory: string;

    constructor(jsonData: any) {
        this.id = jsonData._id
        this.title = jsonData.title
        this.description = jsonData.description
        this.coverImg = jsonData.coverImg
        this.coverImgAssetId = jsonData.coverImgAssetId
        this.minPrice = jsonData.minPrice
        this.rating = jsonData.rating
        this.noOfRatings = jsonData.noOfRatings
        this.isListed = jsonData.isListed
        this.priceTable = jsonData.priceTable as PriceTableInterface[]
        this.gigImgs = Array.isArray(jsonData?.gigImgs)
            ? jsonData.gigImgs.filter((image: unknown) => image && typeof image === 'object') as GigImageInterface[]
            : []
        this.seller = new Seller(jsonData.seller) 
        this.gigMetrics = jsonData.gigMetrics
        this.subcategory = jsonData.subcategory
    }

}